import { DEFAULT_STARTING_BALANCE } from '../config/constants';
import { SimulateBacktestTrades } from '@einhaus/project314-shared';
import type { EntityType, EvaluatedBacktestTrade, SimulateBacktestTradesStats, TradeDirection } from '@einhaus/project314-types';

export const getPerformanceForTrades = (config: {
    trades: EvaluatedBacktestTrade[];
    entityId?: number;
    entityType?: EntityType;
    direction?: TradeDirection | undefined;
    startingBalance?: number;
    skipOverlappingTrades?: boolean;
}): SimulateBacktestTradesStats => {
    const { trades, entityId, entityType, direction, startingBalance, skipOverlappingTrades } = config;

    const filteredTrades: EvaluatedBacktestTrade[] = [];

    for (const trade of trades) {
        const transaction = trade.transactions[0];
        if (!transaction) continue;

        if (entityId && transaction.entityId !== entityId) continue;
        if (entityType && transaction.entityType !== entityType) continue;
        if (direction && transaction.direction !== direction) continue;

        filteredTrades.push(trade);
    }

    const tradeSimulator = new SimulateBacktestTrades({
        startingBalance: startingBalance ?? DEFAULT_STARTING_BALANCE,
        trades: filteredTrades,
        direction,
        skipOverlappingTrades
    });

    tradeSimulator.simulate();

    return tradeSimulator.getStats();
};
